import React from 'react';
import { SortableElement } from 'react-sortable-hoc';

const SortableItem = SortableElement((props: any) => (
  <tr {...props} key={props.index} />
));

export type JTableRowProps<RecordType> = {
  /** Table is sortable */
  sortable: boolean;
  /** Array to sort */
  data?: readonly RecordType[];
  /** sorting Key */
  rowKey?: string;
};

/**
 * Sostituisce il body della tabella in caso di sorting drag&drop
 * */
export const JTableRow = <RecordType extends Record<string, unknown>>({
  sortable = false,
  data,
  rowKey,
  ...otherProps
}: JTableRowProps<RecordType>) => {
  if (sortable && data && rowKey) {
    const index = data.findIndex((x) => {
      // @ts-ignore
      return x[rowKey] === otherProps['data-row-key'];
    });

    return <SortableItem index={index} {...otherProps} />;
  }

  return <tr {...otherProps} data-testid="not-sortable" />;
};
